import { render, staticRenderFns } from "./ItemShopCart.vue?vue&type=template&id=20c8371a&scoped=true&"
import script from "./ItemShopCart.vue?vue&type=script&lang=js&"
export * from "./ItemShopCart.vue?vue&type=script&lang=js&"
import style0 from "./ItemShopCart.vue?vue&type=style&index=0&id=20c8371a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8371a",
  null
  
)

export default component.exports